import type { PayloadAction, Update } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import type { ConnectionInfo } from '../middleware'

export const signalRAdapter = createEntityAdapter<ConnectionInfo>({
  selectId: info => info.url,
})

export const signalRSlice = createSlice({
  name: 'signalR',
  initialState: signalRAdapter.getInitialState(),
  reducers: {
    addConnection(state, action: PayloadAction<ConnectionInfo>) {
      signalRAdapter.upsertOne(state, action.payload)
    },
    updateConnection(state, action: PayloadAction<Update<ConnectionInfo>>) {
      const payload = action.payload
      signalRAdapter.updateOne(state, payload)
    },
  },
})

export default signalRSlice.reducer
